module.exports = __webpack_public_path__ + "static/media/2-2-GKOLpGmm.17fa90f8.mp3";